import { getEnvVar } from './config/RuntimeConfig';
import { isBxpForm } from "./utilities/ElementUtils";

const isBxpAppId = (value?: string): boolean => {
  return typeof value === 'string' && value.toUpperCase().startsWith('BXP-');
};

export function isRuntime(): string {
  if (getEnvVar('NODE_ENV') != 'local') return getEnvVar('IS_RUNTIME');
  let paths = window.location.href.split('/on-form/#/')
  if (paths.length < 2) {
    if(window.location.href.includes("/on-form/fr/")){
      paths = window.location.href.split('/on-form/fr/');
    }else{
      paths = window.location.href.split('/on-form/');
    }
  }
  const appId = paths.length >= 2 ? (paths[1].split('/').filter(Boolean)[0] || '') : '';
  const isBxp = isBxpAppId(appId);
  if (paths.length >= 2 && isBxp) return 'true';
  // if (paths.length >=2) return 'true';
  return getEnvVar('IS_RUNTIME')
}

export function apiUrl(): string {
  if (getEnvVar('NODE_ENV') != 'local') return getEnvVar('LAYOUT_API_URL');

  if (isRuntime() === 'true')
    return getEnvVar('LAYOUT_API_URL_RUNTIME') ?? getEnvVar('LAYOUT_API_URL')
  else
    return getEnvVar('LAYOUT_API_URL')
}